export function exists<T>(e: T, value: T | string | number | null): value is T {
  if (
    value &&
    (Object.values(e as any).includes(value) ||
      Object.values(e as any).includes(Number(value)))
  ) {
    return true;
  }

  return false;
}
